import {
  COLLECT_ONBOARDING_PATH,
  COLLECT_ONBOARDING_SCREENS,
} from "@/utils/const";

export const getOnboardingUrl = (screen: ICollectOnboardingScreens) =>
  `${COLLECT_ONBOARDING_PATH}${COLLECT_ONBOARDING_SCREENS[screen]}`;
